import { Box, Container, useTheme } from "@mui/material";
import React, { useMemo, useState } from "react";
import { Outlet } from "react-router-dom";
import TopNavbar from "./TopNavbar";
import SideDrawer from "./SideDrawer";
import { VanguardNavbar } from "./shared/VanguardNavbar";
import { styles } from "../../assets/styles/styles";

const SidebarLayout = () => {
  const theme = useTheme();
  const [open, setOpen] = useState(true);

  const handleDrawerToggle = () => {
    setOpen((prev) => !prev);
  };

  const contentStyle = useMemo(() => ({
    marginLeft: !open ? "75px" : "calc(224px + 1px)",
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
      ...(!open && {
        transition: theme.transitions.create("margin", {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
      }),
    },
  }), [open, theme]);
  return (
    <>
      <SideDrawer
        sidebarOpen={open}
        handleDrawerToggle={handleDrawerToggle}
        setOpen={setOpen}
      />
      <Container
        maxWidth="false"
        sx={{ mt: 2, mb: 4, padding: "0px!important" }}
      >
        <Box sx={contentStyle}>
          <Outlet />
        </Box>
      </Container>
    </>
  );
};

export default SidebarLayout;
